import Adicionar from './Adicionar';

export const ArquivosAdicionar = Adicionar;
